import { Box, TooltipRenderer, Text } from '@machobear/design-system'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Icon from '@/components/icon'
import { colors } from '@/styles'

const TextInput = styled.input`
  width: ${props => (props.fullWidth ? '100%' : '278px')};
  height: 38px;
  padding-left: 10px;
  font-size: 14px;
  border: none;
  background-color: ${colors.white};
  border-radius: 4px;

  :focus {
    outline: none;
  }

  &::placeholder {
    color: ${colors.mediumGrey};
    opacity: 0.7;
  }
`

const SearchIcon = styled(Icon)`
  flex-shrink: 0;
  cursor: pointer;
  margin-left: 10px;
`

const ClearIcon = styled(Icon)`
  flex-shrink: 0;
  cursor: pointer;
`

const SearchBar = ({ placeholder, onSearch, fullWidth, searchString }) => {
  const { t } = useTranslation()
  const handleChange = e => {
    onSearch(e.target.value)
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      onSearch(searchString)
    }
  }

  return (
    <Box
      width="full"
      display="flex"
      justifyContent="spaceBetween"
      alignItems="center"
      border="borderField"
      borderRadius="small"
    >
      <SearchIcon
        onClick={() => {
          onSearch(searchString)
        }}
        id="search"
        height={16}
        width={16}
      />

      <TextInput
        value={searchString}
        onChange={handleChange}
        type="text"
        placeholder={placeholder}
        onKeyDown={handleKeyPress}
        fullWidth={fullWidth}
        role="search"
      />
      {searchString?.length > 0 ? (
        <TooltipRenderer
          tooltip={
            <Box paddingY="xxxsmall" justifyContent="center">
              <Text weight="strong" size="small">
                {t('l.credit_usage.select_listing_modal.clear_search.text', 'Clear Search')}
              </Text>
            </Box>
          }
        >
          {({ triggerProps }) => (
            <Box
              aria-label="Clear Search"
              {...triggerProps}
              alignItems="center"
              marginX="xsmall"
              marginTop="xxsmall"
            >
              <ClearIcon
                onClick={() => {
                  onSearch('')
                }}
                id="close_button_light"
                height={20}
                width={20}
              />
            </Box>
          )}
        </TooltipRenderer>
      ) : (
        <Box alignItems="center" marginX="xsmall" marginTop="xxsmall">
          <Box style={{ width: '20px', height: '20px' }}></Box>
        </Box>
      )}
    </Box>
  )
}

export default SearchBar
